import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useStore } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import PartnerHeader from '../PartnerHeader';
import { CardBox, PartnerContainer } from '../../../style/partnerStylemain';
import { getLogRequestDetailByOtp, getMaskedMobileNoForLogRequestOtp, requestOTPForPartnerFillMasterData } from '../../../store/publicPartner/action';
import { AlertContainer, alert } from 'react-custom-alert';
import { queryclear } from '../../../store/search/actions';
import PartnerOtpVerification from '../shared/PartnerOtpVerification';

const ALERT_FLOATING_TIME = 3000;

type Props = {}

const PartnerFillMasterDataOtp = (props: Props) => {
    const dispatch = useDispatch();
    const [refCode, setRefCode] = useState<string | undefined>();
    const [maskedMobileNo, setMaskedMobileNo] = useState<string | undefined>();
    const [requestMaskedMobileNo, setRequestMaskedMobileNo] = useState<string | undefined>();
    const [mobileNo, setMobileNo] = useState<string>();
    const [timeLeftSecond, setTimeLeftSecond] = useState<number | undefined>();
    const [loading, setLoading] = useState(false);
    const store = useStore();
    const history = useHistory();
    let { userKey } = useParams<{ userKey: string }>();
    let { code } = useParams<{ code: string }>();
    let { key } = useParams<{ key: string }>();
    const isVerifyingRef = useRef(false);
    const isRequestingOtpRef = useRef(false);

    const handleQueryLoaded = (res: any) => {
        if (res.data == null) return;
        if (res.table === 'log-request-otp') {
            isRequestingOtpRef.current = false;
            setRefCode(res.data.refCode);
            setMaskedMobileNo(res.data.maskedMobileNo);
            setTimeLeftSecond(res.data.timeLeftSecond);
        } else if (res.table === 'log-request-otp-masked-mobile-no') {
            setRequestMaskedMobileNo(res.data.maskedMobileNo);
        } else if (res.table === 'log-request-detail-by-otp') {
            isVerifyingRef.current = false;
            sessionStorage.setItem("partnerList", JSON.stringify(res.data))
            history.push('/partner/fill-master/getDetail/' + userKey + "/" + code + "/" + key)
        }
    }

    const handleQueryFailed = (res: any) => {
        isVerifyingRef.current = false;
        isRequestingOtpRef.current = false;
        setLoading(false);
        alert({ message: res.data.message, type: 'error' });
    }

    useEffect(() => {
        const unsubscribe = store.subscribe(() => {
            var res = store.getState().SearchReducer;
            if (res.isLoading) {
                setLoading(true);
            } else if (res.isLoaded) {
                setLoading(false);
                handleQueryLoaded(res);
            } else if (res.isUpdated) {
                dispatch(queryclear());
            } else if (res.isFailed) {
                handleQueryFailed(res);
            }
        });
        dispatch(getMaskedMobileNoForLogRequestOtp(userKey, code, key));
        return unsubscribe;
    }, []);

    const handleRequestOtp = (captchaToken: string) => {
        if (isRequestingOtpRef.current) return;
        isRequestingOtpRef.current = true;
        dispatch(requestOTPForPartnerFillMasterData(userKey, code, key, mobileNo as any, captchaToken));
    }

    const handleVerify = (otp: string) => {
        if (isVerifyingRef.current) return;
        isVerifyingRef.current = true;
        dispatch(getLogRequestDetailByOtp(userKey, code, key, refCode, otp));
    }

    return (
        <div className='bg-light-gray partner-page' style={{ height: "100vh", fontFamily: "DB Helvethaica" }}>
            <div style={{ position: 'sticky', top: 0 }}>
            </div>
            <div className="student-wrapper-header-inner" style={{ background: "#38383D" }}>
                <PartnerHeader />
            </div>
            <PartnerContainer className='mt-3' style={{ maxWidth: 550 }}>
                <CardBox>
                    <PartnerOtpVerification
                        refCode={refCode}
                        maskedMobileNo={maskedMobileNo}
                        requestMaskedMobileNo={requestMaskedMobileNo}
                        timeLeftSecond={timeLeftSecond}
                        loading={loading}
                        onRequestOtp={handleRequestOtp}
                        onVerifyOtp={handleVerify}
                        requestDescription={<>ระบบจะส่งรหัส OTP ไปยังเบอร์มือถือที่ท่านลงทะเบียนไว้ เพื่อใช้ในการเปิดดูข้อมูลการแนะนำหลักสูตรและสื่อความรู้ที่ท่านสนใจ</>}
                        verifyLabel="ยืนยัน"
                        verifyDescription={<>กรุณากรอกรหัสยืนยันที่ได้รับผ่านทาง SMS<br />เพื่อใช้ในการเปิดดูข้อมูลการแนะนำหลักสูตรและสื่อความรู้ที่ท่านสนใจ</>}
                    />
                </CardBox>
                <AlertContainer floatingTime={ALERT_FLOATING_TIME} />
            </PartnerContainer>
        </div>
    )
}

export default PartnerFillMasterDataOtp
